var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhiteinline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.066,
    height: 46.071,
    viewBox: "0 0 193.066 46.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_w_big",
    transform: "translate(-784.16 945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(784.16 -945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M206.662,120.8l0,.01a4.622,4.622,0,0,0-4.309-4.354,4.561,4.561,0,0,0-3.328,1.169,10.892,10.892,0,0,1-2.931,1.586V107.868a8.3,8.3,0,0,0-8.3-8.3h-11.8a10.254,10.254,0,0,1-5.152-2.065,4.586,4.586,0,1,0-.383,7.13l-.014.022.066-.058c.1-.077.2-.157.3-.242a9.944,9.944,0,0,1,5.859-2.119h.764v-.028H187.8a5.665,5.665,0,0,1,5.665,5.665v11.839h-.022v.01H171.791a6.4,6.4,0,0,0-6.4,6.4v9.3a7.024,7.024,0,0,0,1.63,4.561,6.824,6.824,0,0,0,5.226,2.418h2.966l13.738-.081a7.2,7.2,0,0,0,7.14-7.172V122.859a10.911,10.911,0,0,1,2.964,1.61c.1.085.2.165.3.242l.066.058-.014-.022a4.579,4.579,0,0,0,7.253-3.943Zm-36.956-19.5a1.952,1.952,0,1,1,0-.78A1.956,1.956,0,0,1,169.706,101.3Zm19.232,38.4-14.3.07a20.436,20.436,0,0,1-4.314-.447,4.253,4.253,0,0,1-2.295-3.77v-9.435a3.763,3.763,0,0,1,3.763-3.763h21.656v.018h.016v12.776A4.561,4.561,0,0,1,188.939,139.7Zm13.536-16.74a1.958,1.958,0,1,1,1.526-2.3A1.951,1.951,0,0,1,202.475,122.957Z",
    transform: "translate(-163.16 -96.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M313.49,225.581v1.944a4.552,4.552,0,0,1,2.645-1.443c0-.005,0-.01-.005-.015A8.682,8.682,0,0,0,313.49,225.581Z",
    transform: "translate(-283.203 -199.541)",
    fill: "#b3b9bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(840.707 -938.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M87.888,369.382A4.948,4.948,0,0,0,86,368.165a7.911,7.911,0,0,0-2.758-.426h-10.4v3.348H83.188a2.622,2.622,0,0,1,2.052.688,2.488,2.488,0,0,1,.609,1.7v1.315H77.636a9.339,9.339,0,0,0-2.727.347,4.6,4.6,0,0,0-1.826.986,3.729,3.729,0,0,0-1,1.558,6.519,6.519,0,0,0-.31,2.1,5.339,5.339,0,0,0,1.351,3.89q1.363,1.413,4.45,1.412h8.133a6.788,6.788,0,0,0,1.79-.195,2.364,2.364,0,0,0,1.1-.609,2.193,2.193,0,0,0,.542-1.065,7.46,7.46,0,0,0,.146-1.607v-8.145a7.593,7.593,0,0,0-.329-2.265A4.565,4.565,0,0,0,87.888,369.382Zm-2.021,11.439q0,.888-.95.889H77.612a2.532,2.532,0,0,1-1.869-.572,2.094,2.094,0,0,1-.56-1.528,1.985,1.985,0,0,1,.56-1.491,2.752,2.752,0,0,1,1.936-.542h8.194Z",
    transform: "translate(-71.763 -360.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M119.689,367.764H114.9a6.006,6.006,0,0,0-4.761,1.826q-1.607,1.826-1.613,5.619v16.869h3.476V385.1h7.683a7.166,7.166,0,0,0,5.479-2.131q2.021-2.13,2.021-6.532t-2.021-6.514A7.133,7.133,0,0,0,119.689,367.764Zm2.94,12.717a4.1,4.1,0,0,1-3.3,1.217h-7.305v-6.356a4.807,4.807,0,0,1,.889-3.251,3.949,3.949,0,0,1,3.044-.986h3.415a4.1,4.1,0,0,1,3.3,1.218,6.305,6.305,0,0,1,1.035,4.073,6.54,6.54,0,0,1-1.084,4.085Z",
    transform: "translate(-86.148 -360.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M147.015,368.981a5.744,5.744,0,0,0-1.065,3.841V385.1h3.476V373.352a1.975,1.975,0,0,1,2.234-2.234h6.088V367.77h-7.123A4.607,4.607,0,0,0,147.015,368.981Z",
    transform: "translate(-100.787 -360.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3.513,
    height: 4.036,
    transform: "translate(60.388 0.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3.476,
    height: 17.332,
    transform: "translate(60.388 7.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M198.272,376.4a4.781,4.781,0,0,0-1.826-1.053,9.434,9.434,0,0,0-2.971-.4H189.4a2.927,2.927,0,0,1-1.954-.475,1.826,1.826,0,0,1-.511-1.394,1.931,1.931,0,0,1,.524-1.479,2.5,2.5,0,0,1,1.741-.493h9.582V367.76h-9.619q-3.044,0-4.334,1.364a5.1,5.1,0,0,0-1.315,3.7,6.861,6.861,0,0,0,.262,1.905,3.846,3.846,0,0,0,.938,1.625,4.6,4.6,0,0,0,1.826,1.114,8.92,8.92,0,0,0,2.953.408h4.1a3.131,3.131,0,0,1,1.887.444,1.77,1.77,0,0,1,.572,1.491,1.828,1.828,0,0,1-.524,1.461,2.7,2.7,0,0,1-1.741.444H183.716v3.379h10.075a7.6,7.6,0,0,0,2.593-.4,4.762,4.762,0,0,0,1.772-1.084,4.072,4.072,0,0,0,1-1.656,6.9,6.9,0,0,0,.311-2.119,6.7,6.7,0,0,0-.262-1.905A3.525,3.525,0,0,0,198.272,376.4Z",
    transform: "translate(-115.481 -360.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.513,
    height: 4.036,
    transform: "translate(88.093 0.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3.476,
    height: 17.332,
    transform: "translate(88.093 7.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M244.183,362.938h-7.646a7.208,7.208,0,0,0-5.479,2.131Q229,367.206,229,371.6t2.021,6.532a7.208,7.208,0,0,0,5.479,2.131h4.791a6.017,6.017,0,0,0,4.742-1.826q1.625-1.826,1.625-5.595V355.42h-3.513Zm0,9.74a4.726,4.726,0,0,1-.889,3.214,3.9,3.9,0,0,1-2.989.986h-3.446a4.1,4.1,0,0,1-3.3-1.218,6.259,6.259,0,0,1-1.029-4.061,6.384,6.384,0,0,1,1.035-4.073,3.974,3.974,0,0,1,3.3-1.218h7.305Z",
    transform: "translate(-133.279 -355.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M278.879,378.075q3.184,0,4.529-1.3a4.869,4.869,0,0,0,1.351-3.7,5.339,5.339,0,0,0-1.376-3.921q-1.376-1.394-4.462-1.394h-5.613a7.927,7.927,0,0,0-2.776.426,4.972,4.972,0,0,0-1.869,1.218,4.568,4.568,0,0,0-1.065,1.826,7.549,7.549,0,0,0-.329,2.265v5.911a7.518,7.518,0,0,0,.329,2.283,4.573,4.573,0,0,0,1.065,1.826,4.958,4.958,0,0,0,1.869,1.217,7.921,7.921,0,0,0,2.776.426h10.6v-3.379H273.3a2.655,2.655,0,0,1-2.052-.676,2.472,2.472,0,0,1-.609-1.723v-1.218Zm-8.237-4.56a2.488,2.488,0,0,1,.609-1.7,2.618,2.618,0,0,1,2.052-.688h5.582a2.563,2.563,0,0,1,1.869.609,2.132,2.132,0,0,1,.609,1.577,2.01,2.01,0,0,1-.572,1.51,2.814,2.814,0,0,1-1.985.56h-8.164Z",
    transform: "translate(-148.251 -360.25)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteinline);
export default __webpack_public_path__ + "static/media/logo_white.inline.5611743dedc56e331fde9b6020d46cfa.svg";
export { ForwardRef as ReactComponent };